import { render, staticRenderFns } from "./deviceStatic.vue?vue&type=template&id=2b035204&scoped=true&"
import script from "./deviceStatic.vue?vue&type=script&lang=js&"
export * from "./deviceStatic.vue?vue&type=script&lang=js&"
import style0 from "./deviceStatic.vue?vue&type=style&index=0&lang=css&"
import style1 from "./deviceStatic.vue?vue&type=style&index=1&id=2b035204&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b035204",
  null
  
)

export default component.exports